var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"info-block"},[_c('h4',[_vm._v("Publicaties")]),_c('p',[_vm._v("Informatie over deze tool is nog niet beschikbaar.")])])])
}]

export { render, staticRenderFns }